import React from 'react';
import { Mail, Phone, MapPin,  Briefcase, Award, GraduationCap, Code } from 'lucide-react';
// import './Resume.css';

export default function Resume() {


  const skills = [
    'HTML/CSS',
    'JavaScript',
    'React.JS',
    'Tailwind',
    'Bootstrap',
    'Teamwork',
    'Git/GitHub',
    'Responsive Design'
  ];

  const achievements = [
    {
      title: 'Enhanced Site Performance',
      description: '• Reduced website load time by 30% through optimization techniques, boosting user engagement.',
      status: 'Present'
    },
    {
      title: 'Mobile Optimization Lead',
      description: '• Led a team to develop 15 mobile-friendly websites, improving visitor satisfaction scores by 40%.',
      status: 'Present'
    },
    {
      title: 'API Integration Specialist',
      description: '• Implemented API integration for 20 different applications, increasing system efficiency by 50%.',
      status: 'Present'
    }
  ];

  return (
    <div className="resume-wrapper">
      <div className="resume-container">
        {/* Header Section */}
        <div className="header">
          <h1 className="name">Shibil Khan</h1>
          <div className="title-badge">
            Front End Web Developer
          </div>
          
         
        </div>

        {/* Main Content */}
        <div className="resume-content">
          
          {/* Sidebar */}
          <div className="sidebar">
            {/* Contacts */}
            <div className="section">
              <div className="section-header">
                <Mail size={24} />
                <h2>CONTACTS</h2>
              </div>
              
              <div className="contact-item">
                <MapPin size={18} />
                <span>North Nazimabad, Karachi, PK</span>
              </div>
              
              <div className="contact-item">
                <Phone size={18} />
                <span>03330090357</span>
              </div>
              
              <div className="contact-item">
                <Mail size={18} />
                <span className="email">khanshibil98@gmail.com</span>
              </div>
            </div>

            {/* Skills */}
            <div className="section">
              <div className="section-header">
                <Code size={24} />
                <h2>SKILLS</h2>
              </div>
              
              {skills.map((skill, idx) => (
                <div key={idx} className="skill-item">
                  • {skill}
                </div>
              ))}
            </div>
          </div>

          {/* Main Content */}
          <div className="main-content">
            {/* Professional Summary */}
            <section className="content-section">
              <div className="content-header">
                <Briefcase size={26} />
                <h2>PROFESSIONAL SUMMARY</h2>
              </div>
              <p className="summary-text">
                Front-End Developer skilled in HTML, CSS, JavaScript, and React, focused on building clean, fast, and user-friendly web applications. Experienced in developing front-end interfaces, optimizing websites for accessibility, implementing user authentication and API integrations, and collaborating with designers and back-end developers to meet customer requirements.
              </p>
            </section>

            {/* Key Achievements */}
            <section className="content-section">
              <div className="content-header">
                <Award size={26} />
                <h2>KEY ACHIEVEMENTS</h2>
              </div>

              {achievements.map((achievement, idx) => (
                <div key={idx} className="achievement-item">
                  <div className="achievement-header">
                    <h3>{achievement.title}</h3>
                    <span className="status-badge">{achievement.status}</span>
                  </div>
                  <p className="achievement-desc">{achievement.description}</p>
                </div>
              ))}
            </section>

            {/* Education */}
            <section className="content-section">
              <div className="content-header">
                <GraduationCap size={26} />
                <h2>EDUCATION</h2>
              </div>
              
              <div className="education-item">
                <div className="education-header">
                  <h3>Board of Intermediate Education Karachi</h3>
                  <span className="status-badge">Present</span>
                </div>
                <p className="education-school">The Educators School | Karachi</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}